/* eslint-disable no-magic-numbers */
import { MapSize } from '@/redux/map/map.types';
import { AppDispatch } from '@/redux/store';
import { Map, MapBrowserEvent } from 'ol';
import { updateLastRightClick } from '@/redux/map/map.slice';
import { toLonLat } from 'ol/proj';
import { latLngToPoint } from '@/utils/map/latLngToPoint';
import { handleDataReset } from '@/components/Map/MapViewer/utils/listeners/mouseClick/handleDataReset';
import { FEATURE_TYPE } from '@/constants/features';
import { openContextMenu } from '@/redux/contextMenu/contextMenu.slice';
import { ModelElement, NewReaction } from '@/types/models';
import { clickHandleReaction } from '@/components/Map/MapViewer/utils/listeners/mouseClick/clickHandleReaction';
import getFeatureAtCoordinate from '@/components/Map/MapViewer/utils/listeners/mouseClick/getFeatureAtCoordinate';
import { closeDrawer } from '@/redux/drawer/drawer.slice';
import { resetHighlightReactionsData } from '@/redux/reactions/reactions.slice';
import { clearSearchModelElements } from '@/redux/modelElements/modelElements.slice';
import { clearBioEntitySearchData } from '@/redux/bioEntity/bioEntity.slice';
import { clickHandleAlias } from '@/components/Map/MapViewer/utils/listeners/mouseClick/clickHandleAlias';

/* prettier-ignore */
export const onMapRightClick =
  (
    mapSize: MapSize,
    modelId: number,
    dispatch: AppDispatch,
    isResultDrawerOpen: boolean,
    modelElements: Array<ModelElement>,
    reactions: Array<NewReaction>) =>
    async ({ coordinate, pixel }: Pick<MapBrowserEvent, 'coordinate' | 'pixel'>, mapInstance: Map): Promise<void> => {

      const [lng, lat] = toLonLat(coordinate);
      const point = latLngToPoint([lat, lng], mapSize);
      dispatch(updateLastRightClick({ coordinates: point, modelId }));
      dispatch(handleDataReset);
      if (isResultDrawerOpen) {
        dispatch(closeDrawer());
      }

      dispatch(resetHighlightReactionsData());
      dispatch(clearSearchModelElements());
      dispatch(clearBioEntitySearchData());
      dispatch(openContextMenu(pixel));

      const featureAtCoordinate = getFeatureAtCoordinate({mapInstance, coordinate, point});
      if(!featureAtCoordinate) {
        return;
      }

      const type = featureAtCoordinate.get('type');
      const id = featureAtCoordinate.get('id');

      if([FEATURE_TYPE.ALIAS, FEATURE_TYPE.GLYPH, FEATURE_TYPE.COMPARTMENT].includes(type)) {
        await clickHandleAlias(dispatch)(modelElements, featureAtCoordinate, modelId);
      } else if (type === FEATURE_TYPE.REACTION) {
        clickHandleReaction(dispatch)(modelElements, reactions, id,  modelId);
      }
    };
